import React from "react";

const SubHeadingBanner = ({ imageSrc, title, head1, head2 }) => {
  return (
    <section>
      <div className="relative h-32">
        <img
          src={imageSrc}
          alt={title}
          className="w-full h-full object-cover opacity-25"
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center py-10 text-center">
          <p className="text-base text-gray-600 mb-3">{head1}</p>
          <h2 className="text-3xl font-normal font-serif text-gray-600">
            {head2}
          </h2>
        </div>
      </div>
    </section>
  );
};

export default SubHeadingBanner;
